import { CloseIcon } from "@chakra-ui/icons";
import {
  Button,
  Checkbox,
  Flex,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Text,
  Textarea,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { LiaMousePointerSolid } from "react-icons/lia";
import { getApi, postApi } from "common/services/api";
import moment from "moment";
import { toast } from "react-toastify";
import { jobProfileSchema } from "services/Recruit/schema/jobProfileSchema";
import axios from "axios";
import { constant } from "common/constant";

const AddJobProfile = (props) => {
  const { onClose, isOpen, fetchData } = props;
  const [isChecked, setIsChecked] = useState(false);
  const userId = JSON.parse(localStorage.getItem("user"))._id;
  const [assignmentToData, setAssignmentToData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const [isLoading, setIsLoading] = useState(false);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const [department, setDepartment] = useState([]);
  const [userData, setUserData] = useState();

  const initialValues = {
    title: "",
    department: "",
    hiringManager: "",
    assignedRecruiter: "",
    industry: "",
    salary: "",
    description: "",
    requirements: "",
    benefits: "",
    attachments: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: jobProfileSchema,
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });
  useEffect(() => {
    getDepartments();
    fetchUserData();
  }, []);

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;
  const getDepartments = async () => {
    setIsLoading(true);
    let result = await getApi("api/recruitment/departments/");
    setDepartment(result.data);
    setIsLoading(false);
  };
  const AddData = async () => {
    try {
      setIsLoading(true);

      let response = await postApi("api/recruitment/profiles", values);
      if (response.status === 201) {
        formik.resetForm();
        onClose();
        fetchData();
      } else {
        toast.error("Something went wrong");
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };
  async function onAddAttachmentHandler(e) {
    try {
      const payload = { file: e.target.files[0] };
      const path = "api/recruitment/attachments";
      let result = await axios.post(constant.baseUrl + path, payload, {
        headers: {
          Authorization:
            localStorage.getItem("token") || sessionStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      });
      if (result.status === 201) {
        formik.setFieldValue("attachments", result.data._id);
        if (result.data?.token && result.data?.token !== null) {
          sessionStorage.setItem("token", result.data?.token);
          localStorage.setItem("user", JSON.stringify(result.data?.user));
        }
      }
    } catch (e) {
      toast.error("Something went wrong");
    }
  }
  const fetchUserData = async () => {
    setIsLoading(true);
    let result = await getApi("api/user/");
    setUserData(result?.data?.user);
    setIsLoading(false);
  };
  return (
    <Modal isOpen={isOpen} size={"xl"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader justifyContent="space-between" display="flex">
          Create Job Profile
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={() => (props.from ? onClose(false) : onClose())}
            icon={<CloseIcon />}
          />
        </ModalHeader>
        <ModalBody overflowY={"auto"} height={"700px"}>
          <Grid templateColumns="repeat(12, 1fr)" gap={3}>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Title<Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.title}
                name="title"
                placeholder="Title"
                fontWeight="500"
                borderColor={errors?.title && touched?.title ? "red.300" : null}
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.title && touched.title && errors.title}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Department<Text color={"red"}>*</Text>
              </FormLabel>

              <Select
                fontSize="sm"
                // id={field.name}
                name={"department"}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.department}
                fontWeight="500"
                borderColor={
                  errors?.["department"] && touched?.["department"]
                    ? "red.300"
                    : null
                }
              >
                <option value="">Select Department</option>
                {department &&
                  department.length > 0 &&
                  department.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
              </Select>
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {touched.department && errors.department && errors.department}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Hiring Manager<Text color={"red"}>*</Text>
              </FormLabel>

              <Select
                fontSize="sm"
                placeholder="Hiring Manager"
                // id={field.name}
                name={"hiringManager"}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.hiringManager}
                sx={{
                  option: {
                    maxHeight: "200px",
                    overflowY: "auto",
                  },
                }}
                fontWeight="500"
                borderColor={
                  errors?.hiringManager && touched?.hiringManager
                    ? "red.300"
                    : null
                }
              >
                <option value="">Select Hiring Manager</option>
                {userData &&
                  userData.length > 0 &&
                  userData.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.username}
                    </option>
                  ))}
              </Select>
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.hiringManager &&
                  touched.hiringManager &&
                  errors.hiringManager}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Assigned Recruiter<Text color={"red"}>*</Text>
              </FormLabel>

              <Select
                fontSize="sm"
                placeholder="Assigned Recruiter"
                // id={field.name}
                name={"assignedRecruiter"}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.assignedRecruiter}
                fontWeight="500"
                borderColor={
                  errors?.assignedRecruiter && touched?.assignedRecruiter
                    ? "red.300"
                    : null
                }
              >
                <option value="">Select Assigned Recruiter</option>
                {userData &&
                  userData.length > 0 &&
                  userData.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.username}
                    </option>
                  ))}
              </Select>
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.assignedRecruiter &&
                  touched.assignedRecruiter &&
                  errors.assignedRecruiter}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Industry<Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.industry}
                name="industry"
                placeholder="Industry"
                fontWeight="500"
                borderColor={
                  errors?.industry && touched?.industry ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.industry && touched.industry && errors.industry}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Salary<Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.salary}
                name="salary"
                placeholder="Salary"
                fontWeight="500"
                borderColor={
                  errors?.salary && touched?.salary ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.salary && touched.salary && errors.salary}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Description<Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.description}
                name="description"
                placeholder="Description"
                fontWeight="500"
                borderColor={
                  errors?.description && touched?.description ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.description &&
                  touched.description &&
                  errors.description}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Requirements<Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.name}
                name="requirements"
                placeholder="Requirements"
                fontWeight="500"
                borderColor={
                  errors?.requirements && touched?.requirements
                    ? "red.300"
                    : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.requirements &&
                  touched.requirements &&
                  errors.requirements}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Benefits<Text color={"red"}>*</Text>
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.benefits}
                name="benefits"
                placeholder="Benefits"
                fontWeight="500"
                borderColor={
                  errors?.benefits && touched?.benefits ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.benefits && touched.benefits && errors.benefits}
              </Text>
            </GridItem>
            <GridItem colSpan={{ base: 12, md: 6 }}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                mb="8px"
              >
                Attachments
              </FormLabel>
              <Input
                fontSize="sm"
                onChange={handleChange}
                onBlur={handleBlur}
                name="attachments"
                placeholder="Attachments"
                fontWeight="500"
                accept="audio/*,video/*,image/*,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                padding={"5px"}
                onInputCapture={(e) => {
                  onAddAttachmentHandler(e);
                }}
                type="file"
                borderColor={
                  errors?.attachments && touched?.attachments ? "red.300" : null
                }
              />
              <Text mb="10px" fontSize="sm" color={"red"}>
                {" "}
                {errors.attachments &&
                  touched.attachments &&
                  errors.attachments}
              </Text>
            </GridItem>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button
            sx={{
              marginRight: 4,
              textTransform: "capitalize",
            }}
            variant="outline"
            className="theme-btn2 cancelBtn"
            size="sm"
            onClick={() => {
              formik.resetForm();
              onClose();
            }}
          >
            Close
          </Button>
          <Button
            size="sm"
            className="theme-btn1"
            variant="brand"
            disabled={isLoading ? true : false}
            onClick={handleSubmit}
          >
            {isLoading ? <Spinner /> : "Save"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddJobProfile;
